import { Injectable } from '@angular/core'
import { DateTime } from 'luxon'
import { Appointment, AppointmentAvailability } from './appointment.types'

export const MAX_DAYS_REQUEST = 3

@Injectable({
  providedIn: 'root',
})
export class AppointmentUtils {
  constructor() { }

  calculateNextDates(): Date[] {
    return Array.from({ length: MAX_DAYS_REQUEST }, (_, i) => DateTime.now().plus({ days: i }).toJSDate())
  }

  /**
   * Check if a selected appointment slot is still available in the appointment availability
   * @param selectedAppointment The currently selected appointment
   * @param appointmentAvailability The current appointment availability data
   * @returns true if the slot is still available, false otherwise
   */
  isAppointmentSlotAvailable(
    selectedAppointment: Appointment, 
    appointmentAvailability: AppointmentAvailability
  ): boolean {
    if (!selectedAppointment?.date || !appointmentAvailability?.dates) {
      return false;
    }

    const matchingDate = appointmentAvailability.dates.find(date => 
      date.date.getTime() === selectedAppointment.date.getTime()
    );
    
    if (!matchingDate) {
      return false;
    }
    
    return matchingDate.slots.some(slot => 
      slot.startTime.getTime() === selectedAppointment.slot.startTime.getTime() &&
      slot.endTime.getTime() === selectedAppointment.slot.endTime.getTime()
    );
  }
}
